import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SFuncModal, SIDRender } from 'shj-components'
import { Form, Button, Select, Divider, Row, Col, message, Table, Spin } from 'antd';
import { selectUnionPlan } from '@/services/fmsServices'
import { SelectPlanFn } from './selectPlan'
import dayjs from 'dayjs'
import { getAuth } from '@/utils/auth'
export function PaymentPlanFn({ fn, seePlan, ...rest }) {
    const onClose = () => {
        dialog.destroy();
    };
    const dialog = SFuncModal({
        title: `联查收款计划`,
        width: 1000,
        vanish: true,
        content: <PaymentPlan onClose={onClose} fn={fn} seePlan={seePlan} {...rest} />,
    });
    return dialog;
}
// @ts-ignore
const PaymentPlan = ({ onClose, fn, seePlan, ...rest }) => {
    const auth = getAuth()
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    useEffect(() => {
        initFn();
    }, []);

    const initFn = () => {
        setLoading(true)
        selectUnionPlan({
            orderId: rest.orderId
        }).then(res => {
            setDataSource(res)
            setLoading(false)
        }).catch(err => {
            setLoading(false)
        })
    };
    const onInfo = (record) => {
        onClose()
        seePlan && seePlan(record)
    };
    const changePlan = () => {
        SelectPlanFn({
            fns: () => {
                initFn();
                fn()
            },
            ...{ orderId: rest.orderId },
        });
    };
    const columns = [
        {
            title: '收款计划名称', dataIndex: 'planMainName', key: 'planMainName', width: 140, render: (text, record) => {
                return <SIDRender id={text} onClick={() => onInfo(record)} copy={false}></SIDRender>
            }
        },
        { title: '描述', dataIndex: 'ruleRemarks', key: 'ruleRemarks', width: 140, },
        {
            title: '生效日期', dataIndex: 'effectDate', key: 'effectDate', width: 140, render: (text) => {
                return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
            }
        },
        { title: '来源', dataIndex: 'fromSource', key: 'fromSource', width: 140, },
    ];
    return (
        <div style={{ padding: '15px 15px 50px 15px' }}>
            {/* <Spin spinning={loading}> */}
            {auth['ReceivableListChangeRule'] && (
                <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginBottom: '20px' }}
                    onClick={changePlan}
                >
                    变更收款计划
                </Button>
            )}
            <Table
                loading={loading}
                pagination={false}
                columns={columns}
                size="small"
                dataSource={dataSource}
            />
            {/* </Spin> */}
        </div>
    );
};
